import {
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  Button,
} from "@material-ui/core";
import { Visibility, Download } from "@mui/icons-material";

export default function CardManual({ manual, onView, onDownload }) {
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("pt-BR");
  };

  return (
    <Card>
      <CardContent
        style={{ display: "flex", flexDirection: "column", gap: "4px" }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h3">{manual.NomeManual}</Typography>
          <Chip
            label={manual.Categoria}
            size="small"
            color="secondary"
            style={{ width: "fit-content" }}
          />
        </Box>

        <Typography variant="caption">
          Publicado em: {formatDate(manual.DataCadastro)}
        </Typography>

        <Box display="flex" justifyContent="space-around" marginTop="1rem">
          <Button onClick={() => onView(manual)} variant="contained">
            <Visibility fontSize="small" />
            Visualizar
          </Button>

          <Button onClick={() => onDownload(manual)} variant="contained">
            <Download fontSize="small" />
            Download
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
